/**
 * Company contact details — single source of truth for contact section & footer.
 * India (Jaipur) is the primary office. Dubai details appear on the contact page.
 */
export const CONTACT = {
  email: 'info@codeinventivsolutions.com',
  workingHours: 'Mon – Fri: 10:00 AM – 6:00 PM',
  responseNote: 'We respond within 24 hours. For urgent inquiries, reach us on WhatsApp.',
  phones: [
    {
      label: 'India',
      display: '+91-8769472154',
      tel: '+918769472154',
      whatsapp: 'https://wa.me/918769472154',
    },
    {
      label: 'UAE',
      display: '+971-545476785',
      tel: '+971545476785',
      whatsapp: 'https://wa.me/971545476785',
    },
  ],
  offices: [
    {
      label: 'India Office',
      lines: ['A-37 Balaji Vihar-62, Niwaru Road Jhotwara', 'Jaipur, Rajasthan 302012, India'],
    },
    {
      label: 'UAE Office',
      lines: ['1402, Home to Home, Tecom, Al Barsha', 'Dubai, UAE'],
    },
  ],
  social: [
    { name: 'Facebook', href: 'https://facebook.com/profile.php?id=61583407715494', label: 'Facebook' },
    { name: 'LinkedIn', href: 'https://linkedin.com/company/codeinventiv-solutions', label: 'LinkedIn' },
    { name: 'Instagram', href: 'https://instagram.com/codeinventivsolutions', label: 'Instagram' },
  ],
  // Primary map: Jaipur office
  mapEmbedUrl:
    'https://maps.google.com/maps?q=A-37%20Balaji%20Vihar-62%2C%20Niwaru%20Road%20Jhotwara%2C%20Jaipur%2C%20Rajasthan%20302012&t=&z=15&ie=UTF8&iwloc=&output=embed',
};
